import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// When the URL changes and includes a hash (e.g. navigating "/#about"),
// smooth-scroll to the target element after paint.
export function useHashScroll() {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    // Wait for the target section to mount, then scroll.
    const attempt = (tries = 0) => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (tries < 12) {
        setTimeout(() => attempt(tries + 1), 60);
      }
    };
    attempt();
  }, [location]);
}
